<template>
  <v-dialog persistent v-model="show" width="600" content-class="popup-wrap-1">
    <div class="pa-8">
      <v-form ref="form">
        <h3 class="title-type-4 mb-2">매체 지면 관리</h3>
        <p class="form-coment-1 mt-3 mb-2">
          <v-icon>mdi-alert-circle-outline</v-icon>
          지면 정보 입력 후 저장버튼을 꼭 클릭해주세요.
        </p>

        <div class="section-gap-1">
          <h3 class="title-type-3">
            지면명
            <span class="required">
              <v-icon>mdi-check-circle-outline</v-icon>
              필수
            </span>
          </h3>
          <v-text-field
            placeholder="20자 이내 입력해주세요."
            class="input-custom-2"
            height="40px"
            v-model="invenName"
            :rules="inventoriesNameRules"
            solo
          ></v-text-field>
          <p class="form-coment-1 mt-n2">
            <v-icon>mdi-alert-circle-outline</v-icon>
            등록후 매체명은 변경이 불가합니다.
          </p>
        </div>

        <div class="section-gap-1">
          <h3 class="title-type-3">
            동시 노출 제한
            <span class="required">
              <v-icon>mdi-check-circle-outline</v-icon>
              필수
            </span>
          </h3>
          <v-select
            :items="inventoriesSel"
            label="선택"
            v-model="inventoriesSelChoice"
            :rules="inventoriesSelRules"
            item-color="#000"
            class="input-custom-2"
            height="40px"
            solo
          ></v-select>
        </div>

        <div class="section-gap-1">
          <h3 class="title-type-3">
            지면 옵션 선택
            <span class="required">
              <v-icon>mdi-check-circle-outline</v-icon>
              필수
            </span>
          </h3>
          <p class="text-type-1">
            등록할 매체의 지면들이 사용할 지면 특성만 선택하면 등록을 간편하게
            하실 수 있습니다.
          </p>
          <p class="form-coment-1 mt-2">
            <v-icon>mdi-alert-circle-outline</v-icon>
            지면 옵션 추가는 소스 개발 후 적용 가능합니다.
          </p>
          <div class="mt-2">
            <v-btn
              depressed
              max-height="32px"
              :color="
                this.inventoriesOptions.length <=
                this.inventoriesOptionChx.length
                  ? '#eee'
                  : '#fecd06'
              "
              class="button-type-1"
              @click.prevent="onCheckAll"
            >
              {{
                this.inventoriesOptions.length <=
                this.inventoriesOptionChx.length
                  ? '선택 해제'
                  : '전체 선택'
              }}
            </v-btn>
          </div>
          <ul class="chx-list-type-1 four">
            <li v-for="(option, index) in inventoriesOptions" :key="index">
              <v-checkbox
                v-model="inventoriesOptionChx"
                :value="option.id"
                :label="option.name"
                color="#fecd00"
                off-icon="mdi-checkbox-blank"
                class="checkbox-type-1"
                hide-details
              >
              </v-checkbox>
            </li>
          </ul>
        </div>

        <div class="section-gap-1">
          <h3 class="title-type-3 mb-2">
            지면 샘플 이미지
            <span class="required">
              <v-icon>mdi-check-circle-outline</v-icon>
              필수
            </span>
          </h3>
          <p class="form-coment-1">
            <v-icon>mdi-alert-circle-outline</v-icon>
            지면의 실제 노출 광고 상품 샘플 이미지를 등록합니다.
          </p>
          <div class="file-upload-box-2">
            <div class="file-thumb">
              <img v-if="file.thumb" :src="file.thumb" alt="" />
              <v-icon v-else>mdi-image-outline</v-icon>
            </div>
            <div class="file-text">
              <div class="file-wrap">
                <v-btn
                  large
                  depressed
                  max-height="32px"
                  color="#fecd06"
                  class="button-type-1"
                  type="file"
                >
                  파일 업로드
                </v-btn>
                <input type="file" @change="onFileChange" accept="image/png" />
              </div>
              <p class="form-coment-1 my-2">
                <v-icon>mdi-alert-circle-outline</v-icon>
                PNG 파일만 사용 가능 용량 제한
              </p>
              <p class="file-name mb-0" v-if="file.name">
                {{ file.name }}
              </p>
            </div>
            <div class="file-size">
              <p>Width: 200px ~ 768px</p>
            </div>
          </div>
        </div>

        <div class="section-gap-1">
          <h3 class="title-type-3">
            지면 설명
            <span class="required">
              <v-icon>mdi-check-circle-outline</v-icon>
              필수
            </span>
          </h3>
          <v-textarea
            solo
            placeholder="50자 이내 입력해주세요."
            color="#eee"
            height="74px"
            class="input-custom-2"
            v-model="invenNote"
            :rules="inventoriesGuideRules"
          ></v-textarea>
        </div>

        <div class="d-flex justify-end mt-2">
          <v-btn
            large
            depressed
            max-height="40px"
            min-width="104px"
            color="#fff"
            class="button-type-1"
            @click="cancel"
          >
            취소
          </v-btn>
          <v-btn
            large
            depressed
            max-height="40px"
            min-width="104px"
            color="#fecd06"
            class="button-type-1 ml-2"
            @click="registerInventories"
          >
            저장
          </v-btn>
        </div>
      </v-form>
    </div>

    <SystemAlert :persistent="true" v-model="showSystemAlert">
      <div slot="noti-text">{{ logResult }}</div>
      <div slot="noti-btns">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1"
          @click.stop="closePopup"
        >
          확인
        </v-btn>
      </div>
    </SystemAlert>
  </v-dialog>
</template>

<script>
import bus from '@/utils/bus';
import { updateInventory } from '@/api/inventory';
import { optionsList } from '@/api/options';
import { uploadWithNewPermission } from '@/api/etc';

import SystemAlert from '~@/modal/SystemAlert.vue';

export default {
  props: {
    value: Boolean,
    inventories: Object,
    inventoriesOptions: Array,
  },
  components: { SystemAlert },
  data: () => ({
    file: {
      img: null,
      name: null,
      thumb: null,
    },
    inventoriesName: '',
    inventoriesNameRules: [
      v => !!v || '지면명을 입력해 주세요.',
      v => (v && v.length <= 20) || '20자 이내로 입력해주세요.',
    ],
    inventoriesSel: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    inventoriesSelChoice: '',
    inventoriesSelRules: [v => !!v || '동시 노출 제한을 선택해 주세요.'],
    inventoriesOptionChx: [],
    inventoriesGuide: '',
    inventoriesGuideRules: [
      v => !!v || '지면 설명을 입력해주세요.',
      v => (v && v.length <= 50) || '50자 이내로 입력해주세요.',
    ],
    resultType: '',
    logResult: '',
    showSystemAlert: false,
  }),
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    invenName: {
      get() {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties, prettier/prettier
        this.inventories ? (this.file.thumb = this.inventories.sample_image) : (this.file.thumb = '');
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties, prettier/prettier
        return this.inventories ? (this.inventoriesName = this.inventories.name) : '';
      },
      set(value) {
        this.inventoriesName = value;
      },
    },
    invenNote: {
      get() {
        const otps = [];
        this.inventories
          ? this.inventories.options.forEach(opt => {
              otps.push(opt.id);
            })
          : [];
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.inventoriesOptionChx = otps;

        // eslint-disable-next-line vue/no-side-effects-in-computed-properties, prettier/prettier
        this.inventories ? (this.inventoriesSelChoice = this.inventories.overlap_cnt + '') : '';

        // eslint-disable-next-line vue/no-side-effects-in-computed-properties, prettier/prettier
        return this.inventories ? (this.inventoriesGuide = this.inventories.note) : '';
      },
      set(value) {
        this.inventoriesGuide = value;
      },
    },
  },
  methods: {
    onCheckAll() {
      this.inventoriesOptions.length <= this.inventoriesOptionChx.length
        ? (this.inventoriesOptionChx = [])
        : this.inventoriesOptions.forEach(opt => {
            this.inventoriesOptionChx.push(opt.id);
          });
    },
    onFileChange(e) {
      const file = e.target.files[0];
      this.file.name = file.name;
      this.file.thumb = URL.createObjectURL(file);
      this.file.img = file;
    },
    async registerInventories() {
      bus.$emit('start:spinner');
      try {
        const options = this.inventoriesOptionChx.reduce(
          (previous, current) => {
            previous.push({ id: current });
            return previous;
          },
          [],
        );

        // 예시 이미지를 골랐으면 저장 직전에 업로드하고, 실패하면 저장하지 않는다
        let sampleImage = null;
        if (this.file.img) {
          try {
            sampleImage = await uploadWithNewPermission('png', this.file.img);
          } catch (error) {
            console.log(error.response);
            bus.$emit('end:spinner');
            this.showSystemAlert = true;
            this.logResult =
              '이미지 업로드에 실패하였습니다. 다시 시도해주세요.';
            return;
          }
        }

        const resultData = () => {
          const result = {
            name: this.inventoriesName.trim(),
            overlap_cnt: this.inventoriesSelChoice * 1,
            options: options,
            note: this.inventoriesGuide,
          };
          if (sampleImage) result.sample_image = sampleImage;
          return result;
        };

        const { data } = await updateInventory(
          this.inventories.id,
          resultData(),
        );

        if (data.result === 'success') {
          bus.$emit('end:spinner');
          this.resultType = data.result;
          this.showSystemAlert = true;
          this.logResult = '매체 지면이 수정되었습니다.';
          this.show = false;
        }
      } catch (error) {
        bus.$emit('end:spinner');

        const { data } = error.response;
        this.resultType = data.result;
        if (data.result === 'DuplicatedEntry') {
          this.showSystemAlert = true;
          this.logResult = '이미 사용중인 지면명이 있습니다.';
        } else if (data.result === 'ParameterValidation') {
          this.showSystemAlert = true;
          this.logResult = '등록에 실패하였습니다. 재등록 부탁드립니다.';
        } else {
          console.log(error.response);
        }
      }
    },
    closePopup() {
      const type = this.resultType;
      this.showSystemAlert = false;
      if (type === 'success') {
        this.$emit('refreshList');
      }
    },
    cancel() {
      this.$refs.form.reset();
      this.file = { img: '', name: '', thumb: '' };
      this.show = false;
      this.$emit('cancelProps');
    },
  },
  created() {
    bus.$emit('start:spinner');
    // this.getOptions();
  },
};
</script>
